import React from 'react';
import { Tag, Typography } from 'antd';
import { regionColors } from './GridItem';

const { Title } = Typography;

const RegionLegend: React.FC = () => {
  return (
    <div style={{ marginBottom: 24, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
      <Title level={5} style={{ margin: 0, alignSelf: 'center' }}>图例:</Title>
      <Tag color={regionColors.FR1}>Framework 1</Tag>
      <Tag color={regionColors.CDR1}>CDR 1</Tag>
      <Tag color={regionColors.FR2}>Framework 2</Tag>
      <Tag color={regionColors.CDR2}>CDR 2</Tag>
      <Tag color={regionColors.FR3}>Framework 3</Tag>
      <Tag color={regionColors.CDR3}>CDR 3</Tag>
      <Tag color={regionColors.FR4}>Framework 4</Tag>
    </div>
  );
};

export default RegionLegend;
